import { Sizes } from '../constants/size';
import type { IconProps } from '../types/icon-props';

export const CardPos = (props: IconProps) => {
  const { size = 'md', fill = 'var(--grey-1)', stroke = 'var(--grey-1)', ...rest } = props;

  return (
    <svg
      width={Sizes[size]}
      height={Sizes[size]}
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <g>
        <g>
          <path
            d="M3.92969 16.2869L15.8797 4.33691"
            stroke={stroke}
            strokeWidth="1.5"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M11.1016 18.6868L12.3016 17.4868"
            stroke={stroke}
            strokeWidth="1.5"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M13.793 15.9964L16.183 13.6064"
            stroke={stroke}
            strokeWidth="1.5"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M3.60127 10.6467L10.2413 4.00672C12.3613 1.88672 13.4213 1.87672 15.5213 3.97672L20.4313 8.88671C22.5313 10.9867 22.5213 12.0467 20.4013 14.1667L13.7613 20.8067C11.6413 22.9267 10.5813 22.9367 8.48127 20.8367L3.57127 15.9267C1.47127 13.8267 1.47127 12.7767 3.60127 10.6467Z"
            stroke={stroke}
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M2 22.4062H22"
            stroke={stroke}
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
      </g>
    </svg>
  );
};

CardPos.displayName = 'CardPos';
